//accordions block in cart page

  var accordionElements = document.querySelectorAll('[data-accordion-cart-toggle]');
  var accordions = [];
  
  accordionElements.forEach(function(element) {
    element.addEventListener('click', function() {
      var accordionBody = this.nextElementSibling;
      var index = accordions.findIndex(acc => acc.body === accordionBody);

      if (index !== -1) {
        accordions[index].body.style.maxHeight = '0px';
        accordions[index].toggle.classList.remove('is-open');
        accordions.splice(index, 1);
      } else {
        accordions.forEach(acc => {
          acc.body.style.maxHeight = '0px';
          acc.toggle.classList.remove('is-open');
        });
        accordions = [];
      }
  
      if (index === -1) {

        accordionBody.style.maxHeight = '500px';
        element.classList.add('is-open');
        accordions.push({ body: accordionBody, toggle: element });
      }
    });
  });